import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import MyLocationPage from './MyLocationPage/MyLocationPage';

const MyLocationFeature = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} exact>
        <MyLocationPage />
      </Route>
    </Switch>
  );
};

export default MyLocationFeature;
